<template >
  <div>
    <div class="sr-comInfo">
      <div class="sr-layout-wrap">

        <el-image src="https://sara-infinity.com/logo.jpg" style="float: left; height: 10%;width: 10%"  />

        <div class="sr-comInfo-r" style="margin-top: 3%;margin-left: 3%">
          <div class="sr-comInfo-title J-title-comName">
            <div class="title-txt">
              <a href="https://www.sara-infinity.com">
                <h1 style="font-size: 22px">
                  GUANGZHOU ZHIZHEN VEHICLE PARTS CO.,LTD.<i class="ob-icon icon-down"></i>
                </h1>
              </a>
            </div>

          </div>
          <div class="sr-comInfo-sign">
            <div class="sign-item">
              <i class="el-icon-message"></i> <span class="txt-year">525205929@qq.com</span>
              <div class="tip arrow-top tip-gold">
                <div class="tip-con">
                  <p class="tip-para">Suppliers with verified business licenses</p>
                </div>
                <span class="arrow arrow-out">
                                    <span class="arrow arrow-in"></span>
                                </span>
              </div>
            </div>
            <div class="sign-item as-logo" data-title="Audited by an independent third-party inspection agency">
              <i class="el-icon-phone"></i>
              <span class="txt-year">+86 18680557608</span>
            </div>
          </div>
        </div>
      </div>
    </div>


    <el-menu
        default-active="3"
        class="el-menu-demo"
        mode="horizontal"
        @select=""
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
        style="padding-left: 21.2%">
      <el-menu-item index="1"><router-link to="/home" >Home</router-link></el-menu-item>
      <el-menu-item index="2"><router-link to="/products" >Products</router-link></el-menu-item>
      <el-menu-item index="3" ><router-link to="/aboutUs" >About Us</router-link></el-menu-item>
      <el-menu-item index="4" disabled><router-link to="" >Solutions</router-link></el-menu-item>
      <el-menu-item index="5"><router-link to="/sendUs" >Send Us</router-link></el-menu-item>
    </el-menu>

    <!------------------------------------------------------------------分割线------------------------------------------------------------------------------------------------>







    <div class="sr-layout-wrap sr-layout-resp" style="margin-top: 2%">


      <div class="sr-layout-nav">
        <div class="sr-layout-block J-about-nav">
          <div class="sr-layout-subblock sr-side-proGroup">
            <div class="sr-txt-title">
              <h2 class="sr-txt-h2">About Us</h2>
            </div>
            <ul class="sr-side-proGroup-list">
              <li class="J-about-nav-item selected">
                <a ><h3>Company Profile</h3></a>
              </li>
              <li class="J-about-nav-item">
                <a ><h3>waiting...</h3></a>
              </li>
              <li class="J-about-nav-item">
                <a ><h3>waiting...</h3></a>
              </li>
              <li class="J-about-nav-item">
                <a ><h3>waiting...</h3></a>
              </li>
            </ul>
            <div class="sr-txt-title review-title" style="margin-top: 3%">
              <h2 class="sr-txt-h2">Business Performance</h2>
            </div>
            <ul class="sr-side-proGroup-list">
              <li class="">
                <a ><h3>waiting...</h3></a>
              </li>
            </ul>
          </div>
        </div>

      </div>






      <div class="sr-layout-main">

        <div class="com-block-tab cf">
          <a class="tab-item current J-tab-item"><h3>Company Profile</h3></a>


        </div>
        <div class="company-profile-content" id="products-comInfos">
          <div class='richtext-nav swiper-container J-richTextNav-comInfo' style="display: none">
            <ul class="richtext-nav-ul">
              <li class="richtext-nav-item active" data-achor="richNav_1">
                Company Profile </li>
              <li class="richtext-nav-item" data-achor="richNav_2">
                wating </li>
              <li class="richtext-nav-item" data-achor="richNav_3">
                wating </li>
              <li class="richtext-nav-item" data-achor="richNav_4">
                wating </li>
            </ul>
            <div class="toolbar">
              <div class="arrow-pre"><i class="ob-icon icon-left"></i></div>
              <div class="arrow-next"><i class="ob-icon icon-right"></i></div>
            </div>
          </div>
          <div class="sr-layout-block J-block sr-comProfile" id="richNav_1">
            <div class="sr-txt-title">
              <h2 class="sr-txt-h2">Company Profile</h2>

            </div>
            <div class="sr-comProfile-info-wrap cf">
              <div class="sr-comProfile-info-l ">
                <div class="sr-proSlide sr-comProfile-slider J-comProfile-slider">
                  <div class="swiper-container J-comProfile-container">
                    <!-- Additional required wrapper -->
                    <div class="swiper-wrapper">
                      <!-- Slides -->
                      <div class="slider-item swiper-slide J-comProfile-slide J-play-video swiper-video c" >
                        <div class="sr-proList-pic-cut">
                          <img src="https://sara-infinity.com/gs.png"  title="Watch Video">
                          <div class="play-bg"></div>
                        </div>
                      </div>




                    </div>
                    <div class="sr-proSlide-pager J-comProfile-pagination"></div>
                    <div class="sr-proSlide-btn-left J-comProfile-left">
                      <i class="ob-icon icon-left-big"></i>
                    </div>
                    <div class="sr-proSlide-btn-right J-comProfile-right">
                      <i class="ob-icon icon-right-big"></i>
                    </div>
                  </div>
                </div>

              </div>
              <div class="sr-comProfile-infos infos-top">
                <table>
                  <tr>
                    <td width="0" >
                    </td>
                    <td class="info-label-td">
                      <span class="info-label-txt">Business Type:</span>
                    </td>
                    <td title="Manufacturer/Factory" >
                      Manufacturer/Factory
                    </td>
                  </tr>
                  <tr>
                    <td width="0" >
                    </td>
                    <td class="info-label-td">
                      <span class="info-label-txt">Business Range:</span>
                    </td>
                    <td title="Auto, Motorcycle Parts &amp; Accessories" >
                      Auto, Motorcycle Parts &amp; Accessories
                    </td>
                  </tr>
                  <tr>
                    <td width="0" >
                    </td>
                    <td class="info-label-td">
                      <span class="info-label-txt">Main Products:</span>
                    </td>
                    <td >
                      <a href="javascript:void(0)" rel="nofollow" ads-data="" class="J-searchProdsByKeyWord"
                         cz-value="Motorcycle Cylinder">Motorcycle Cylinder</a>
                      ,
                      <a href="javascript:void(0)" rel="nofollow" ads-data="" class="J-searchProdsByKeyWord"
                         cz-value="Piston">Piston</a>
                      <form id="searchProdsByKeyword" name="searchInKeywordList" method="get" action="/product/keywordSearch">
                        <input type="hidden" id="keyWord4Search" name="searchKeyword" value="" />
                        <input type="hidden" id="viewType" name="viewType" value="0" />
                      </form>
                    </td>
                  </tr>
                  <tr>
                    <td width="0" >
                    </td>
                    <td class="info-label-td">
                      <span class="info-label-txt">Main Markets:</span>
                    </td>
                    <td title="North America, South America, Eastern Europe, Southeast Asia, Africa, Oceania, Mid East, Eastern Asia, Western Europe" >
                      North America, South America, Eastern Europe, Southeast Asia, Africa, Oceania, Mid East, ...
                    </td>
                  </tr>
                  <tr>
                    <td width="0" >
                    </td>
                    <td class="info-label-td">
                      <span class="info-label-txt">OEM/ODM Availability:</span>
                    </td>
                    <td title="OEM, ODM" >
                      Yes </td>
                  </tr>
                </table>
                <div class=" no-yes-link ">
                  <table class="sgs-serail-wrap">

                  </table>
                </div>

              </div>
            </div>
            <div class="J-txt-wrap sr-comProfile-intro">
              <p class="intro-cnt J-txt-cnt">
                Established in the vibrant market of China, our company specializes in the international trade of motorcycle components. With a keen focus on quality and innovation, we seamlessly navigate the global market, connecting manufacturers and distributors to drive the wheels of the motorcycle parts industry forward.
              </p>
              <a href="javascript:void(0);" class="sr-comProfile-more J-show-more" rel="nofollow" style="display:none;">View All <i class="ob-icon icon-down"></i></a>
            </div>
          </div>
          <div class="sr-layout-block pad-block J-block" id="richNav_2">
            <div class="sr-txt-title">
              <h2 class="sr-txt-h2">Trade Capacity</h2>
            </div>
            <div class="sr-comProfile-infos no-yes ">
              <div class="sr-comProfile-item">
                <div class="sr-comProfile-label">
                  International Commercial Terms(Incoterms):
                </div>
                <div class="sr-comProfile-fields">
                  FOB, EXW, CFR, CIF
                </div>
              </div>
              <div class="sr-comProfile-item">
                <div class="sr-comProfile-label">
                  Terms of Payment:
                </div>
                <div class="sr-comProfile-fields">
                  T/T, Western Union, Small-amount payment
                </div>
              </div>
              <div class="sr-comProfile-item">
                <div class="sr-comProfile-label">
                  Average Lead Time:
                </div>
                <div class="sr-comProfile-fields">
                  Peak Season Lead Time: 1-3 months, Off Season Lead Time: one month
                </div>
              </div>

              <div class="sr-comProfile-item">
                <div class="sr-comProfile-label">Export Year:</div>
                <div class="sr-comProfile-fields">2008-01-06</div>
              </div>
              <div class="sr-comProfile-item">
                <div class="sr-comProfile-label">Export Percentage:</div>
                <div class="sr-comProfile-fields">100%</div>
              </div>
              <div class="sr-comProfile-item">
                <div class="sr-comProfile-label">
                  Main Markets:
                </div>
                <div class="sr-comProfile-fields">
                  North America, South America, Eastern Europe,  Africa, Oceania, Mid East,  Western Europe
                </div>
              </div>


            </div>
          </div>
          <div class="sr-layout-block pad-block J-block" id="richNav_3">
            <div class="sr-txt-title">
              <h2 class="sr-txt-h2"> Production Capacity</h2>
            </div>
            <div class="sr-comProfile-infos no-yes ">
              <div class="sr-comProfile-item">
                <div class="sr-comProfile-label">
                  Factory Address:
                </div>
                <div class="sr-comProfile-fields">
                  zhongshan, guangdong, China
                </div>
              </div>
              <div class="sr-comProfile-item">
                <div class="sr-comProfile-label">
                  R&D Capacity:
                </div>
                <div class="sr-comProfile-fields">
                  OEM, ODM
                </div>
              </div>
              <div class="sr-comProfile-item">
                <div class="sr-comProfile-label">
                  No. of R&D Staff:
                </div>
                <div class="sr-comProfile-fields">
                  Less than 10 People
                </div>
              </div>
              <div class="sr-comProfile-item">
                <div class="sr-comProfile-label">No. of Production Lines:</div>
                <div class="sr-comProfile-fields">
                  Above 10
                </div>
              </div>
              <div class="sr-comProfile-item">
                <div class="sr-comProfile-label">Annual Output Value:</div>
                <div class="sr-comProfile-fields">
                  US$5 Million - US$10 Million
                </div>
              </div>
            </div>
          </div>




        </div>


        <div class="sr-layout-block J-msg-block" faw-module="supplier_inquiry" faw-exposure>
          <div class="sr-txt-title">
            <h2 class="sr-txt-h2">Send your message to this supplier</h2>
          </div>
          <div class="sr-layout-content sr-sendMsg">
            <div class="sr-sendMsg-form obelisk-form">
              <input type="hidden" id="showRoomUrl">

                <input type="hidden" id="loginStatu" value="0" />
                <div class="sr-sendMsg-row">
                  <div class="sr-sendMsg-label">
                    <em>*</em>From:
                  </div>
                  <div class="sr-sendMsg-field J-quick-inquiry-email-wrap">
                    <input class="input-text sr-sendMsg-input" name="senderMail" type="text" placeholder="Enter your email address" value="" />
                  </div>
                </div>
                <div class="sr-sendMsg-row">
                  <div class="sr-sendMsg-label">
                    <em>*</em>To:
                  </div>
                  <div class="sr-sendMsg-field">

                    <span class="sr-sendMsg-name">Ms. Zhang</span>
                  </div>
                </div>
                <div class="sr-sendMsg-row">
                  <div class="sr-sendMsg-label">
                    <em>*</em>Message:
                  </div>
                  <div class="sr-sendMsg-field">
                    <textarea class="input-textarea sr-sendMsg-area" name="content" id="inquiryContent" cols="90" rows="5" placeholder="We suggest you detail your product requirements and company information here." maxlength="4000"></textarea>
                    <p class="sr-sendMsg-tips">Enter between 20 to 4,000 characters.</p>
                  </div>
                </div>

                <div class="sr-sendMsg-row">
                  <div class="sr-sendMsg-field">

                    <button fun-inquiry-supplier type="submit" class="btn btn-main sr-sendMsg-btn" id="inquirySend" @click="send()">Send</button>
                    <span class="sr-sendMsg-promote">This is not what you are looking for?</span>

                  </div>
                </div>

            </div>
          </div>
        </div>
      </div>









    </div>









    <!-----------------------------------------------------------------------------------底部------------------------------------------------------------------------->
    <div class="m-footer pad-footer m-sr-footer">
      <div class="grid">
        <div class="m-footer-simple-links pad-footer-simple">
          <div class="m-footer-simple-links-group pad-footer-hide">
            <div class="m-footer-simple-links-row">
              <a>{{language?"热门产品":"Hot Products"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"中国产品":"China Products"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"中国制造商/供应商":"Chinese Manufacturers/Suppliers"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"中国批发":"China Wholesale"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"批发价格":"Wholesale Price"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"行业网站":"Industry Sites"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"区域渠道":"Regional Channels"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"产品指数":"Product Index"}}</a>

            </div>

          </div>
          <div class="m-footer-simple-links-group pad-footer-oneline">
            <div class="m-footer-simple-links-row m-footer-copyright">
              Copyright &copy; 2023-2024 <a class="J-focusChinaLink" href="https://www.sara-infinity.com/"
                                            rel="nofollow"
                                            target="_blank">{{language?"广州至臻机车配件有限公司":"GUANGZHOU ZHIZHEN VEHICLE PARTS CO.,LTD."}}</a>&nbsp;{{language?"保留所有权利":"All Rights Reserved."}}

            </div>
            <span class="m-gap-line"></span>
            <div class="m-footer-simple-links-row">
              <a rel="nofollow" target="_self">{{language?"保留所有权利":"User Agreement"}}</a>
            </div>
          </div>
          <div style="display: flex;justify-content: center;width: 100%">

            <div class="m-footer-simple-links-row m-footer-govIcon pad-hide" style="color: blue" >
              <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44011102483772" rel="noreferrer" target="_blank"><i class="m-ico m-ico-police-new"></i>粤公网安备44011102483772</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" data-v-644aa589="" style="margin-left: 20px;">粤ICP备2024199978号</a>
            </div>
          </div>
        </div>
      </div>
    </div>



  </div>
</template>

<script>
export default {
  data() {
    return {
      localImage: require('@/assets/img/logo.jpg'),
      loading: false,
      passFocus: false,
      isCetc: true,
      formWidth: '',
      bgImage: '',
      form: {
        username: '',
        password: '',
        platform: ''
      },
      list: []
    }
  },
  methods: {

    send() {
      this.$message.success("Successfully");


    },

    isIE() {
      if (window.ActiveXObject || "ActiveXObject" in window) {
        this.$message.info('ie浏览器不兼容！')
        return true;
      }
      return false;
    },

  },
  mounted() {
    let random = Math.floor(Math.random() * 5) + 1;
    this.bgImage = {
      backgroundImage: 'url(' + require('../assets/img/bg.jpg'),
      backgroundRepeat: 'no-repeat',

    };
    if (this.isIE()) {
      this.$confirm('此平台不兼容ie浏览器，使用ie浏览器可能会出现未知错误', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

      });
    }

    this.formWidth = 'width: 500px;'

  }
}
</script>

<style scoped>
.catalogForm .form-label {
  width: 190px;
}

.catalogForm .form-label em {
  color: #e64545;
  margin-right: 5px;
}

.catalogForm .form-fields {
  margin-left: 200px;
}

.shipping-cost-tm .tm-status-off {
  background: none;
  padding: 0;
  color: #1470cc
}

</style>
